import DialogGuide from 'global/guides/Dialog'
import { useEscalasOutletContext } from 'pages/Escalas'
import { useNavigate, useParams } from 'react-router-dom'
import { escalas } from 'service/api/endpoints/escalas'
import { toast } from 'sonner'

function ExcluirEscala() {
    const { id } = useParams()
    const navigate = useNavigate()

    const { isLoading, mutate } = escalas.mutations.useDelete({
        invalidateQuery: true,
    })

    const data = useEscalasOutletContext().data.find(
        item => item.id === Number(id),
    )

    const handleSubmit = () => {
        mutate(Number(id), {
            onSuccess: () => {
                toast.success('Escala removida com sucesso!')
                navigate(-1)
            },
            onError: err => {
                if (err.statusCode === 400) {
                    toast.error(err.message)
                } else {
                    toast.error('Erro ao remover escala')
                }
            },
        })
    }

    return (
        <DialogGuide.Root
            height="auto"
            width="27rem"
            loading={isLoading}
            onSubmit={handleSubmit}
        >
            <DialogGuide.Title>Excluir Escala</DialogGuide.Title>
            <DialogGuide.Content>
                Você tem certeza que deseja excluir {data?.descricao}?
            </DialogGuide.Content>
            <DialogGuide.Actions>
                <DialogGuide.Actions.SecondaryButton>
                    Cancelar
                </DialogGuide.Actions.SecondaryButton>
                <DialogGuide.Actions.PrimaryButton color="error">
                    Excluir
                </DialogGuide.Actions.PrimaryButton>
            </DialogGuide.Actions>
        </DialogGuide.Root>
    )
}

export default ExcluirEscala
